import api from "../utils/axios";
import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";

const CONTRACTOR_COMPANIES_KEY = ["contractorCompanies"];

// GET all contractor companies
export const useContractorCompaniesQuery = (status) => {
  return useQuery({
    queryKey: status
      ? [...CONTRACTOR_COMPANIES_KEY, status]
      : CONTRACTOR_COMPANIES_KEY,
    queryFn: async () => {
      const params = status ? `?status=${status}` : "";
      const res = await api.get(`/admin/contractorCompany${params}`);
      return res.data?.data || [];
    },
  });
};

// GET single contractor company by ID
export const useContractorCompanyByIdQuery = (id, options = {}) => {
  return useQuery({
    queryKey: [...CONTRACTOR_COMPANIES_KEY, id],
    queryFn: async () => {
      const res = await api.get(`/admin/contractorCompany/${id}`);
      return res.data?.data || null;
    },
    enabled: !!id,
    ...options,
  });
};

// CREATE contractor company
export const useAddContractorCompanyMutation = (options = {}) => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async (data) => {
      const res = await api.post("/admin/contractorCompany", data);
      return res.data;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: CONTRACTOR_COMPANIES_KEY });
    },
    ...options,
  });
};

// UPDATE contractor company
export const useUpdateContractorCompanyMutation = (options = {}) => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async ({ id, ...data }) => {
      const res = await api.put(`/admin/contractorCompany/${id}`, data);
      return res.data;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: CONTRACTOR_COMPANIES_KEY });
    },
    ...options,
  });
};

// DELETE contractor company (soft delete)
export const useDeleteContractorCompanyMutation = (options = {}) => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async (id) => {
      const res = await api.delete(`/admin/contractorCompany/${id}`);
      return res.data;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: CONTRACTOR_COMPANIES_KEY });
    },
    ...options,
  });
};